var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"pm-diagram"},[_c('VueApexCharts',{attrs:{"type":_vm.chartType,"options":_vm.options,"series":_vm.data}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }